/* eslint-disable no-useless-escape */
/* eslint-disable react/jsx-no-target-blank */
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import EditableCard from 'modules/common/editableCard.component';
import { getClientDetails, updateClient } from 'modules/clients/clients.actions';
import { connect } from 'react-redux';
import { UPDATE_CLIENT_FAILURE } from 'modules/clients/types';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import { showToast } from 'modules/layout/layout.actions';
import { vendorSearchInfo } from 'modules/authorizations/details/global/DestServices/formData/formDataConstants';

const ClientOverviewTable = props => {

  const { clientDetails, enumerations, vendors, history } = props;

  const [isLoading, setIsLoading] = useState(false);

  const summaryTabs = [{ header: 'Client Details', order: 1 }];

  const industries =
    enumerations && enumerations.industries && enumerations.industries.length > 0
      ? enumerations.industries.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const clientStatus =
    enumerations && enumerations.clientStatusTypes && enumerations.clientStatusTypes.length > 0
      ? enumerations.clientStatusTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const selectedVendor = clientDetails?.vendorRecordId && clientDetails?.vendorRecordId !== '' ? vendors.find(v => v.vendorId === clientDetails.vendorRecordId) : null;

  const fields = [
    {
      header: 'Short Name',
      accessorKey: 'shortName',
      type: 'text',
      required: false,
      value: clientDetails ? clientDetails.shortName : '',
      tab: 1
    },
    {
      header: 'Legal Name',
      accessorKey: 'legalName',
      type: 'text',
      required: false,
      value: clientDetails ? clientDetails.legalName : '',
      tab: 1
    },
    {
      header: 'Website',
      accessorKey: 'website',
      type: 'text',
      required: false,
      value: clientDetails ? clientDetails.website : '',
      tab: 1
    },
    {
      header: 'Phone',
      accessorKey: 'phone',
      type: 'text',
      required: false,
      value: clientDetails ? clientDetails.phone : '',
      tab: 1
    },
    { header: 'Fax', accessorKey: 'fax', type: 'text', required: false, value: clientDetails ? clientDetails.fax : '', tab: 1 },
    {
      header: 'Industry',
      accessorKey: 'industryId',
      type: 'dropdown-v2',
      required: false,
      options: industries,
      value: clientDetails ? clientDetails.industryId : '',
      tab: 1
    },
    {
      header: 'Prev Provider',
      accessorKey: 'previousProvider',
      type: 'text',
      required: false,
      value: clientDetails ? clientDetails.previousProvider : '',
      tab: 1
    },
    {
      header: 'Is ERC Member',
      accessorKey: 'isERCMember',
      type: 'checkbox',
      required: false,
      value: clientDetails ? clientDetails.isERCMember : '',
      tab: 1
    },
    {
      header: 'Status',
      accessorKey: 'clientStatusId',
      type: 'dropdown-v2',
      required: false,
      options: clientStatus,
      value: clientDetails ? clientDetails.clientStatusId : '',
      tab: 1
    },
    {
      header: 'Has PT Codes',
      accessorKey: 'isPtCodeProcessActive',
      type: 'checkbox',
      required: false,
      value: clientDetails ? clientDetails.isPtCodeProcessActive : false,
      tab: 1
    },
    {
      header: 'Client Vendor Record',
      accessorKey: 'vendorRecordId',
      type: 'advanced-search',
      searchInfo: vendorSearchInfo(vendors),
      nameKey: 'companyName',
      nameValue: selectedVendor?.companyName || '',
      required: false,
      value: clientDetails?.vendorRecordId || null,
      onClickNavigation: () => history.push(`/partners/${clientDetails?.vendorRecordId}`),
      tab: 1,
    },
    //     {
    //   header: 'Client Vendor Record',
    //   accessorKey: 'vendorRecordName',
    //   type: 'text',
    //   required: false,
    //   value: selectedVendor?.companyName || 'N/a',
    //   tab: 1
    // },
  ];

  const updateFields = async (tab, values) => {
    setIsLoading(true);

    let newVals = { ...clientDetails };

    newVals.shortName = values.shortName;
    newVals.legalName = values.legalName;
    newVals.website = values.website;
    newVals.phone = values.phone;
    newVals.fax = values.fax;
    newVals.industryId = values.industryId;
    newVals.previousProvider = values.previousProvider;
    newVals.isERCMember = values.isERCMember;
    newVals.clientStatusId = values.clientStatusId;
    newVals.isPtCodeProcessActive = values.isPtCodeProcessActive;
    newVals.vendorRecordId = values.vendorRecordId;

    const resp = await props.updateClient(newVals);
    if (resp.type === UPDATE_CLIENT_FAILURE) {
      props.showToast('Failed to update client info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      await props.getClientDetails(clientDetails.clientRecordId);
      props.showToast('Client info updated successfully.', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
      setIsLoading(false);
      return true;
    }
  };

  return <EditableCard tabs={summaryTabs} summaries={fields} numColumns={5} isLoading={isLoading} hideEdit={false} updateFields={updateFields} />;
};

ClientOverviewTable.propTypes = {
  classes: PropTypes.object.isRequired,
  formikProps: PropTypes.object.isRequired
};

export default compose(
  connect(null, {
    updateClient,
    showToast,
    getClientDetails
  })
)(ClientOverviewTable);
